export default [
  {
    path: "/compliance/assessments",
    name: "compliance-assessments",
    meta: { title: "Compliance Assessments", authRequired: true },
    component: () => import("../views/compliance/ComplianceAssessments.vue"),
  },
  {
    path: "/compliance/assessments/:id",
    name: "compliance-assessment-detail",
    meta: { title: "Assessment Details", authRequired: true },
    component: () => import("../views/compliance/ComplianceAssessmentDetail.vue"),
  },
];
